import { render, staticRenderFns } from "./NewAdvertisementButton.vue?vue&type=template&id=410a6fb3"
import script from "./NewAdvertisementButton.vue?vue&type=script&lang=js"
export * from "./NewAdvertisementButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports